module.exports = __webpack_public_path__ + "img/0220805141516.860bce1f.jpg";